var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsconditionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 263,
    viewBox: "0 0 290 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_97_1876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.76 241.691C158.907 241.326 166.695 238.319 172.063 232.432C188.341 214.583 176.215 177.021 144.979 148.534C113.744 120.048 75.226 111.425 58.948 129.274C53.5795 135.16 51.3004 143.191 51.7774 152.333C70.3663 151.592 94.5712 161.761 115.505 180.853C136.44 199.945 148.79 223.113 149.76 241.691Z",
    fill: "url(#paint0_linear_97_1876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0328 213.172C117.269 241.658 155.786 250.282 172.064 232.433L142.59 264.751C126.312 282.6 87.7948 273.977 56.5589 245.49C25.3231 217.004 13.1973 179.442 29.4753 161.593L58.9492 129.274C42.6712 147.123 54.797 184.685 86.0328 213.172Z",
    fill: "url(#paint1_linear_97_1876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.971 193.214C203.118 192.849 210.905 189.841 216.274 183.955C232.552 166.106 220.426 128.543 189.19 100.057C157.954 71.5704 119.437 62.9471 103.159 80.7961C97.7904 86.6827 95.5114 94.7135 95.9884 103.856C114.577 103.114 138.782 113.284 159.716 132.375C180.651 151.467 193.001 174.635 193.971 193.214Z",
    fill: "url(#paint2_linear_97_1876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.244 164.694C161.48 193.18 199.997 201.804 216.275 183.955L186.801 216.273C170.523 234.122 132.006 225.499 100.77 197.012C69.534 168.526 57.4083 130.964 73.6863 113.114L103.16 80.7959C86.8822 98.645 99.0079 136.207 130.244 164.694Z",
    fill: "url(#paint3_linear_97_1876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.18 144.736C247.327 144.371 255.114 141.364 260.483 135.477C276.761 117.628 264.635 80.0658 233.399 51.5793C202.163 23.0928 163.646 14.4695 147.368 32.3186C141.999 38.2052 139.72 46.236 140.197 55.3783C158.786 54.6365 182.991 64.8063 203.925 83.8979C224.86 102.99 237.21 126.158 238.18 144.736Z",
    fill: "url(#paint4_linear_97_1876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.453 116.217C205.689 144.703 244.206 153.327 260.484 135.477L231.01 167.796C214.732 185.645 176.215 177.022 144.979 148.535C113.743 120.049 101.617 82.4865 117.895 64.6374L147.369 32.3188C131.091 50.1679 143.217 87.7303 174.453 116.217Z",
    fill: "url(#paint5_linear_97_1876)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_97_1876",
    x: 22.2422,
    y: 23.022,
    width: 245.473,
    height: 251.026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2221
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_97_1876"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_1876",
    x1: 144.979,
    y1: 148.534,
    x2: 104.453,
    y2: 192.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#125B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_97_1876",
    x1: 98.3136,
    y1: 199.706,
    x2: 56.559,
    y2: 245.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_97_1876",
    x1: 189.19,
    y1: 100.057,
    x2: 148.664,
    y2: 144.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#125B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_97_1876",
    x1: 142.525,
    y1: 151.228,
    x2: 100.77,
    y2: 197.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_97_1876",
    x1: 233.399,
    y1: 51.5793,
    x2: 192.873,
    y2: 96.0174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_97_1876",
    x1: 186.734,
    y1: 102.751,
    x2: 144.979,
    y2: 148.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022321"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsconditionImg);
export default __webpack_public_path__ + "static/media/terms&conditionImg.fa56ee2ebc2dfd27525c0ddcd23e56ff.svg";
export { ForwardRef as ReactComponent };